import React, { Fragment } from "react";
import img1 from "assets/images/Agent-Network-Locations-Banner.png";
import ContentSection from "./agent_table";
import PageBanner from "components/public-dashboard/components/page_banner";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function Agents() {
    useDocumentTitle(
    "Bill Payment Locations Near You | YOOZ",
    "Pay utility bills in cash or with a debit card, at a YOOZ Bill Pay Agent in your Area. Skip the long lines and travelling long distances. Find one closest to you!"
  );
  return (
    <Fragment>
      <PageBanner img={img1} />
      <ContentWrapper>
        <ContentSection />
      </ContentWrapper>
    </Fragment>
  );
}
